import { LucideMaximize, LucideMinimize } from "lucide-react"
import { useToggleFullscreen } from "~/hooks"
import useIsPhone from "~/hooks/useIsPhone"
import { cn } from "~/utils"
import { Tooltip } from "../ui"
import { ControlButton } from "./control-button"

export default function FullscreenControl({
  className,
}: {
  className?: string
}) {
  const { isFullscreen, toggleFullscreen } = useToggleFullscreen()
  const isPhone = useIsPhone()

  return (
    <Tooltip.Provider>
      <Tooltip delayDuration={200}>
        <Tooltip.Trigger asChild>
          <ControlButton
            className={cn(className, isPhone && "!h-8 !px-3")}
            aria-label={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
            onClick={() => {
              toggleFullscreen()
            }}
          >
            {isFullscreen ? (
              <LucideMinimize className="h-5 w-5 text-white" />
            ) : (
              <LucideMaximize className="h-5 w-5 text-white" />
            )}
          </ControlButton>
        </Tooltip.Trigger>
        <Tooltip.Content>Fullscreen</Tooltip.Content>
      </Tooltip>
    </Tooltip.Provider>
  )
}
